import React, {Fragment} from 'react';

import icon1 from "../Images/Contacto/1.png"
import icon2 from "../Images/Contacto/2.png"
import icon3 from "../Images/Contacto/3.png"
import icon4 from "../Images/Contacto/4.png"
import icon5 from "../Images/Contacto/5.png"
import icon6 from "../Images/Contacto/6.png"

import Contacto from '../Components/Contacto'

const Contactos = () => {

    return(
        <Fragment>
            <div className='container'>
                <div className='center titulo_3 '>
                    <p>
                        Contáctanos <br/>
                        <span style={{color:"#A741AF"}}>¡Hagamos equipo!</span>
                    </p>
                </div>
                <div style={{display:"flex", justifyContent:"center", flexWrap:"wrap"}}>
                    <div className='flex_4'>
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d17759.319720992757!2d-103.43851327444226!3d20.651789892595612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428af637e6bd6c3%3A0x516c20566411c4d9!2sSoftware%20Over!5e0!3m2!1ses-419!2smx!4v1661973525209!5m2!1ses-419!2smx" 
                        className='mapa' title="mapa software over" style={{border:"none", height:"calc(100% - 30px)"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                    <div className='flex_5'>
                        <div className='box_5'>
                            <div className='flex_6'>
                                <a target="_blank" rel="noopener noreferrer" href="tel:+523333702640">
                                    <img src={icon1} alt="" />
                                </a>
                                <a style={{marginLeft:"20px"}} target="_blank" rel="noopener noreferrer" href="https://wa.me/523333702640?text=¡Hola buen día! ¿Me podrías dar información?">
                                    <img src={icon2} alt="" />
                                </a>
                            </div>
                            <p className='texto_3' style={{color:"#9FA4AF", margin:"0"}}>
                                33 3370 2640
                            </p>
                        </div>
                        <div className='box_5'>
                            <img src={icon3} alt="" />
                            <p className='texto_3' style={{color:"#9FA4AF", margin:"0"}}>
                                Anillo Periferico Poniente. 10003-Interior 8 y 9, <br/> 
                                Industrial El Colli, 45069 Zapopan, Jal.
                            </p>
                        </div>
                        <div className='box_5'>
                            <div className='flex_6'>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/softwareover/">
                                    <img src={icon6} alt="" />
                                </a>
                                <a style={{margin:"25px"}} target="_blank" rel="noopener noreferrer" href="mailto:softwareover@gmail.com?Subject=¡Hola buen día! &body=¡Hola buen día!%0E¿Me podrías dar más información?">
                                    <img src={icon4} alt="" />
                                </a>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/SoftwareOver">
                                    <img src={icon5} alt="" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Contacto/>
        </Fragment>
    )
}

export default Contactos;